import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.secondary,
    padding: 4,
    borderRadius: 2,
    fontWeight: 'bold'
  }
}))
